import { createFileRoute } from "@tanstack/react-router";
import AgentWatchesPage from "@/pages/AgentWatchesPage";

export const Route = createFileRoute("/_app/watches/")({
  component: AgentWatchesPage,
});
